import React from "react";
import { BiSolidCheckCircle, BiSolidErrorCircle } from "react-icons/bi";

// Kit field message: red + error icon (default) or green + check icon (tone="success").
// size="sm" inside a panel.
export const ErrorMessage = (props) => {
  const { children, className = "", hideIcon, size = "md", tone = "error", ...rest } = props;
  const Icon = tone === "success" ? BiSolidCheckCircle : BiSolidErrorCircle;
  return <div {...rest} className={`${className} pt-kit-8 ${tone === "success" ? "text-success" : "text-danger"} ${size === "sm" ? "text-kit-sm" : "text-kit-md"}`} >
    {!hideIcon && (
      <Icon className="inline-block translate-y-[5%] mr-kit-8 mb-kit-4" />
    )}
  {children}</div>;
};

// Same message from a { error } / { success } object (what the auth pages keep in state).
export const FieldMessage = ({ message, children, ...rest }) => {
  const text = children ?? message?.error ?? message?.success;
  if (!text) return null;
  return (
    <ErrorMessage tone={children == null && !message?.error ? "success" : "error"} {...rest}>
      {text}
    </ErrorMessage>
  );
};

const InputError = ({ errors, names }) => {

  // Filter out all errors that match any of the names
  const relevantErrors = errors?.filter((error) => names.includes(error.input)) || [];

  // If there are relevant errors, map through them and display each one
  if (relevantErrors.length > 0) {
    return (
      <div className="my-kit-6 ">
        {relevantErrors.map((err, i) => (
          <ErrorMessage key={i}>{err.message}</ErrorMessage>
        ))}
      </div>
    );
  }

  // If there are no relevant errors, return null
  return null;
};

export default InputError;